@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <!-- One row: the title, then each control under its own label, then the buttons. Everything
    sits on its bottom edge so the title lines up with the boxes rather than their labels. -->
    <div style="display:flex; align-items:flex-end; flex-wrap:wrap; column-gap:20px; row-gap:12px; margin-bottom:20px;">
      <h3 style="margin:0; align-self:center; white-space:nowrap;" i18n>Itinerary Report for period: </h3>
      <div>
        <label style="display:block; margin-bottom:4px;">From Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">To Date:</label>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'130px'}"></p-datepicker>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">Resources:</label>
        <p-multiselect [options]="resources" optionLabel="name" [(ngModel)]="chosenresources" (onPanelHide)="applyResourceFilter()" placeholder="All Resources" [style]="{'width':'200px'}"></p-multiselect>
      </div>
      <div>
        <label style="display:block; margin-bottom:4px;">Tags:</label>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" placeholder="Select Tag(s)" [style]="{'width':'200px'}">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
      </div>
      <!-- Kept together so they wrap as a pair rather than the export button dropping alone. -->
      <div style="display:flex; gap:8px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" style="background-color: #22C55E;border-color: #22C55E;" (click)="doneDate()">
          Go
        </button>
        @if (ReportRows) {
          <button
            type="button"
            pButton
            pRipple
            (click)="exportCsv()"
            pTooltip="Export to CSV"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
          <!-- Hidden for now - not asked for. collapseAll/expandAll are still in the component.
          <button
            type="button"
            pButton
            pRipple
            class="p-button-secondary"
            (click)="collapseAll()"
            pTooltip="Collapse all resources"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-angle-double-up" aria-hidden="true"></span></button>
          <button
            type="button"
            pButton
            pRipple
            class="p-button-secondary"
            (click)="expandAll()"
            pTooltip="Expand all resources"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-angle-double-down" aria-hidden="true"></span></button>
          -->
          }
        </div>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table #ItineraryTable
          [columns]="cols"
          [value]="ReportRows"
          responsiveLayout="scroll"
          rowGroupMode="subheader"
          groupRowsBy="resourceId"
          [customSort]="true"
          (sortFunction)="keepOrder()">
          <ng-template #header>
            <tr>
              <th width="9%">Sales ID</th>
              <th width="10%">Start Date/Time</th>
              <th width="9%">Name</th>
              <th width="14%">Email</th>
              <th width="8%">Phone</th>
              <th width="13%">Package</th>
              <th width="12%">Resource</th>
              <th width="5%">Finishes</th>
              <th width="13%">Original Itinerary</th>
              <th style="text-align: center;" width="5%">Guests</th>
              <th width="12%">Admissions</th>
              <th width="6%">Waiver</th>
            </tr>
          </ng-template>
          <ng-template #groupheader let-rowData>
            <!-- Clicking the heading folds its section shut or opens it again. -->
            <tr style="cursor:pointer;" (click)="toggleSection(rowData)">
              <td colspan="12" style="font-size:18px; font-weight:bold; background-color:#f6f6f6;">
                <span class="pi" [class.pi-chevron-down]="!collapsed.has(rowData.resourceId)" [class.pi-chevron-right]="collapsed.has(rowData.resourceId)" style="margin-right:8px;"></span>{{sectionTitle(rowData)}}
              </td>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            @if (!collapsed.has(rowData.resourceId)) {
            <!-- A timeslot sub-heading inside the resource section, drawn once per slot. -->
            @if (rowData.firstOfSlot) {
              <tr>
                <td colspan="12" style="font-weight:bold; padding-left:24px; background-color:#fbfbfb;">
                  <span class="pi pi-clock" style="margin-right:8px;"></span>{{rowData.timeslot}}
                </td>
              </tr>
            }
            <tr style="cursor:pointer;" (click)="editdata(rowData.bookingId)">
              <td>{{rowData.bookingIdHR}}</td>
              <td>{{rowData.startDateTime}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.email}}</td>
              <td>{{rowData.phone}}</td>
              <td>{{rowData.packageName}}</td>
              <td>{{rowData.resourceLabel}}</td>
              <td>{{rowData.endtime}}</td>
              <td style="white-space: pre-line;">{{rowData.itinerary}}</td>
              <td style="text-align: right;">{{rowData.guests}}</td>
              <td>{{rowData.admissions}}</td>
              <td>{{rowData.waiver}}</td>
            </tr>
            }
          </ng-template>
          <ng-template #footer>
            @if (ReportRows == null || ReportRows.length == 0) {
              <tr>
                <td style="text-align: center;" colspan="12">
                  There is no data for the selected date range.
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    </div>
  }
